import React from 'react';
import { NavLink } from 'react-router-dom';
import { IBrandProps } from '../../../helpers/types';
import { StyledBrand, StyledBrandLogo, StyledBrandTitle } from './styled';

const Brand = ({ title, logo, size, link = true, locale, customer }: IBrandProps): JSX.Element => (
  <StyledBrand
    {...(link &&
      (customer
        ? { tag: NavLink, to: `/${locale}/account`, exact: true }
        : { tag: NavLink, to: `/${locale}/`, exact: true }))}
    data-test-id="NavBarBrand"
  >
    <StyledBrandLogo src={logo} alt={title} size={size} data-test-id="NavBarBrand-logo" />
    <StyledBrandTitle data-test-id="NavBarBrand-title">{title}</StyledBrandTitle>
  </StyledBrand>
);

export default Brand;
